import React, { useEffect, useState } from 'react'
import { user } from '../Join/join';
import socketIo from 'socket.io-client'
import './chat.css'
import SendLogo from '../../Images/send.png'
import Message from '../Message/message'
import ReactScrollToBottom from 'react-scroll-to-bottom'
import closeIcon from '../../Images/closeIcon.png'
let socket;
const ENDPOINT = 'https://v3solution-chat-app.herokuapp.com/'
const Chat = () => {
    const [id, setid] = useState("")
    const [message, setmessage] = useState([])
    const send = () => {
        const message = document.getElementById('chatInput').value;
        socket.emit('message', { message, id });
        document.getElementById('chatInput').value = "";
    }

    console.log(message);
    useEffect(() => {
        socket = socketIo(ENDPOINT, { transports: ['websocket'] });

        socket.on('connect', () => {
            alert('Connected');
            setid(socket.id);

        })
        console.log(socket);
        socket.emit('joined', { user })

        socket.on('welcome', (data) => {
            setmessage([...message, data])
            console.log(data.user, data.message);
        })

        socket.on('userJoined', (data) => {
            setmessage([...message, data])
            console.log(data.user, data.message);
        })

        socket.on('leave', (data) => {
            setmessage([...message, data])
            console.log(data.user, data.message)
        })

        return () => {
            socket.emit('disconnect');
            socket.off();
        }
    }, [])

    useEffect(() => {
        socket.on('sendMessage', (data) => {
            setmessage([...message, data])
            console.log(data.user, data.message, data.id);
        })
        return () => {
            socket.off()
        }
    }, [message])

    return (
        <div className="chatPage">
            <div className="chatContainer">
                <div className="header">
                    <h1>V3 Private Chat Room</h1>
                    <a href="/"><img src={closeIcon} alt="close" /></a>
                </div>
                <ReactScrollToBottom className="chatBox">
                    {message.map((item, i) => <Message user={item.id === id ? "" : item.user} message={item.message} classs={item.id === id ? "right" : "left"} />)}
                </ReactScrollToBottom>
                <div className="inputBox">
                    <input onKeyPress={(event) => event.key === 'Enter' ? send() : null} type="text" id="chatInput" />
                    <button onClick={send} className="sendBtn"><img src={SendLogo} alt="logo" /></button>
                </div>
            </div>
        </div>
    )
}

export default Chat
